import { useMutation, useQueryClient } from "react-query"
import employeesService from "api/employeesService"

export interface IAddEmployeeBody {
  fullName: string
}

const useUpdateEmployeeMutation = () => {
  const queryClient = useQueryClient()
  return useMutation(async (data: any) => {
    try {
      const res = await employeesService.updateEmployee(data)

      return res.data.data
    } catch (err: any) {
      return {
        err: err.message,
        errStatus: err.response.status,
      }
    }
  }, {
    onMutate: async newEmployee => {
      await queryClient.cancelQueries(['employees', newEmployee.id])
      
      const previousEmployees = queryClient.getQueryData(['employees', newEmployee.id])

      queryClient.setQueryData(['employees', newEmployee.id], newEmployee)
      
      // return { previousEmployees, newEmployee }
    }
  })
}

export default useUpdateEmployeeMutation
